import { apiClient } from '@lib/axios';
import type { NotificationsResponse } from '@appTypes/shell';

export const notificationService = {
  getNotifications: (params?: { page?: number; limit?: number }) =>
    apiClient.get<NotificationsResponse>('/notifications', { params }),

  markRead: (id: string) =>
    apiClient.post(`/notifications/${id}/read`),

  markAllRead: () =>
    apiClient.post('/notifications/read-all'),
};
